import "./app.postcss";
import App from './App.svelte'
import * as i18n from "./i18n";


import * as Sentry from "@sentry/svelte";


if (window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1") {
    Sentry.init({
        dsn: "https://977c1a26ec6a976795585482f2c1651a@sentry.upce.cz/3",
        // dsn: "https://f87d51cc19f07bc3abdaa7d56e64eecc@o4508447667978240.ingest.de.sentry.io/4508447673679952",
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        ignoreErrors: [


            ],
        denyUrls:[
            /.*\/node_modules\/suneditor\/src\/lib\/core\.js/
        ],
            // Tracing
        tracesSampleRate: 0.01, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [/^https:\/\/hap2\.upce\.cz/, /^https:\/\/hap2-demo\.upce\.cz/],
        // Session Replay
        replaysSessionSampleRate: 0.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}

const app = new App({
  target: document.getElementById('app'),
})

export default app
